import React from 'react'

import { useUserGroupByUserId } from 'utils/hooks/useUserGroup'
import { useAuth } from 'utils/auth'

const WHITELISTED_USER_GROUPS = ['skp-beta-user']

const useResetToggle = () => {
  const { session } = useAuth()

  const hasMultiplePageGroups = React.useMemo(() => {
    const groups = session?.user?.groups ?? []
    return groups.length === 10
  }, [session])

  const RESET_ENABLED =
    process.env.NEXT_PUBLIC_RESET_DATA_SKP_BUTTON_ENABLED === 'true'

  const { isLoading, userHasOneOfRoles } = useUserGroupByUserId({
    enabled: RESET_ENABLED && hasMultiplePageGroups,
  })

  const hasGroupsFromAPI = userHasOneOfRoles(WHITELISTED_USER_GROUPS)

  const hasGroupsFromSession = React.useMemo(() => {
    const groups = session?.user?.groups ?? []
    return groups.some(({ name }) => WHITELISTED_USER_GROUPS.includes(name))
  }, [session])

  if (!RESET_ENABLED) {
    return {
      enabled: false,
      isLoading: false,
    }
  }

  if (hasMultiplePageGroups) {
    return {
      isLoading,
      enabled: hasGroupsFromAPI,
    }
  }

  return {
    isLoading: false,
    enabled: hasGroupsFromSession,
  }
}

export default useResetToggle
